import { Component, OnInit, Input } from '@angular/core';
import { Group, User } from 'src/app/models/group';
import { UserService } from 'src/app/services/user.service';
import { UserGroupService } from 'src/app/services/user-group.service';
import { InvitationService } from 'src/app/services/invitation.service';
import { Invitation } from 'src/app/models/invitation';
import { ActivatedRoute } from '@angular/router';
import { EmailService } from 'src/app/services/email.service';

@Component({
  selector: 'app-group-members',
  templateUrl: './group-members.component.html',
  styleUrls: ['./group-members.component.css']
})
export class GroupMembersComponent implements OnInit {

  @Input() group: Group;
  inputEmails: string;
  currentStep: number = 1;
  message: string;
  output: any = {};
  currentUser: User;

  constructor(
    private userService: UserService,
    private invitationService: InvitationService,
    private emailService:EmailService,
    private usergroupService: UserGroupService,
    private route: ActivatedRoute) {
  }

  onModalShow() {
    this.output = {};
  }

  ngOnInit() {
    this.currentUser = this.route.snapshot.data.currentUser;
    this.group.members = [];
    this.onModalShow();

    this.usergroupService.getMembers(this.group.id).valueChanges().subscribe(userIds => {
      this.group.members = [];
      Object.keys(userIds).forEach(id => {
        this.userService.getById(id).valueChanges().subscribe(res => {
          if (res) {
            res['id'] = id;
            this.group.members.push(res);
          }
        })
      })
    })

    this.invitationService.getInvitationByGroup(this.group.id).snapshotChanges().subscribe(res => {
      this.group.invitations = [];
      res.forEach(r => {
        var val = r.payload.val();
        val['id'] = r.key;
        this.group.invitations.push(new Invitation(val));
      });
    })
  }

  invite() {
    var invitationSent = false;

    if (this.inputEmails.trim().length == 0) return;
    this.currentStep++;

    // split inputEmails by ;
    var emails = this.inputEmails.split(';');

    // validate each email format
    if (!this.validateEmails(emails)) return;

    // search for user by email
    for (var i = 0; i < emails.length; i++) {
      var email = emails[i];
      // create only if invitation doesn't exist
      if (this.doesInvitationExist(email) == true) {
        continue;
      }

      // create invitation
      var invitation = new Invitation(null);
      invitation.groupId = this.group.id;
      invitation.groupName = this.group.name;
      invitation.inviteeEmail = email;
      invitation.inviterEmail = this.currentUser.email;
      invitation.inviterName = this.currentUser.name;
      this.invitationService.create(invitation);
      this.emailService.sendInvitation(invitation).subscribe(
        data => {console.log(data)}, // success path
        error => {console.log(error)} // error path
      );
      invitationSent = true;
    }
    // if found, add to user group
    // if not found, generate password, register email, register user, add to usergroup
    // send invitation email
    if (invitationSent) {
      this.output.message = 'Invitations sent.';
      this.output.error = false;
    }
  }

  removeInvitation(invitation: Invitation) {
    console.log(invitation);
    this.invitationService.decline(invitation.id);
  }

  removeMember(user: User) {
    console.log(user);
    this.usergroupService.remove(user.id, this.group.id);
  }

  private doesInvitationExist(email) {
    var i = this.group.invitations.findIndex(m => m.inviteeEmail == email);
    if (i >= 0) return true;
    i = this.group.members.findIndex(m => m.email == email);
    return i >= 0;
  }

  private validateEmails(emails: string[]): boolean {
    for (var i = 0; i < emails.length; i++) {
      var email = emails[i].trim();
      console.log(email);
      if (!this.isEmailValid(email)) {
        this.output.message = `'${email}' is not a valid email. Please retry.`;
        this.output.error = true;
        return false;
      }
    }
    return true;
  }

  private isEmailValid(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  private generateRandom(charsNum: number): number {
    var digits = Math.pow(10, charsNum);
    var num = Math.floor(Math.random() * 9 * digits) + digits;
    return num;
  }

  private getInvitations(list): Promise<Invitation[]> {
    return new Promise((resolve, reject) => {
      list.valueChanges().subscribe(res => {
        var invitations: Invitation[] = [];
        res.forEach(r => {
          invitations.push(new Invitation(r));
        });
        resolve(invitations);
      }, reject);
    });
  }
}
